import React from "react";
import { Plus } from "lucide-react";

export default function PayrollProcessingToolbar({
  search,
  setSearch,
  monthFilter,
  setMonthFilter,
  yearFilter,
  setYearFilter,
  statusFilter,
  setStatusFilter,
  months,
  years,
  onAdd,
}) {
  return (
    <div className="finance-toolbar">

      <input
        type="text"
        className="finance-search"
        placeholder="Search Employee..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <select
        className="finance-select"
        value={monthFilter}
        onChange={(e) => setMonthFilter(e.target.value)}
      >
        <option value="All">All Months</option>
        {months.map((month) => (
          <option key={month} value={month}>
            {month}
          </option>
        ))}
      </select>

      <select
        className="finance-select"
        value={yearFilter}
        onChange={(e) => setYearFilter(e.target.value)}
      >
        <option value="All">All Years</option>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>

      <select
        className="finance-select"
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
      >
        <option value="All">All Status</option>
        <option value="Processed">Processed</option>
        <option value="Pending">Pending</option>
        <option value="Draft">Draft</option>
      </select>

      <button
        className="finance-primary-btn"
        onClick={onAdd}
      >
        <Plus size={18} />
        Generate Payroll
      </button>

    </div>
  );
}